// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export { default } from './InAppMessaging';
export { InAppMessageInteractionEvent, } from './types';
//# sourceMappingURL=index.js.map